import SubPage from "../components/SubPage";

export default function HowItWorks() {
  return (
    <SubPage tKey="ds.page_how" image="/img/advisor-talk.jpg"
      sections={[
        { title: "ds.page_how.s1_title", body: "ds.page_how.s1_body" },
        { title: "ds.page_how.s2_title", body: "ds.page_how.s2_body" },
        { title: "ds.page_how.s3_title", body: "ds.page_how.s3_body" },
        { title: "ds.page_how.s4_title", body: "ds.page_how.s4_body" },
      ]} />
  );
}
